import React from 'react'

export enum ButtonIconKind {
  primary = 'primary',
  orange = 'orange',
  brand = 'brand',
}
export interface ButtonIconProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: string
  size?: 'small' | 'medium' | 'large'
  type?: 'button' | 'submit' | 'reset'
  className?: string
  label?: string
  asChild?: boolean
  outline?: boolean
  selected?: boolean
  rounded?: boolean
  kind?: ButtonIconKind
}
